<template>
  <!--
      作者：kmdshop
      时间：2020-06-20
      描述：diy组件-参数设置-顶部设置栏
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!--页面标题-->
      <el-form-item label="页面标题：">
        <el-input v-model="curItem.params.title"></el-input>
        <p class="gray">小程序端顶部显示的标题</p>
      </el-form-item>
      <!--页面名称-->
      <el-form-item label="页面名称：">
        <el-input v-model="curItem.params.name"></el-input>
        <p class="gray">页面名称仅用于后台查找</p>
      </el-form-item>
      <!--分享标题-->
      <el-form-item label="分享标题：">
        <el-input v-model="curItem.params.share_title"></el-input>
        <p class="gray">小程序端转发时显示的标题</p>
      </el-form-item>
      <!--个人编码设置-->
      <!--<el-form-item label="个人编码设置:">-->
      <!--  <el-radio-group v-model="curItem.style.code_status">-->
      <!--    <el-radio :label="0">禁用</el-radio>-->
      <!--    <el-radio :label="1">启用</el-radio>-->
      <!--  </el-radio-group>-->
      <!--</el-form-item>-->
      <!--个人编码文字描述-->
      <!--<el-form-item label="编码描述设置:">-->
      <!--    <el-input v-model="curItem.params.code_desc"></el-input>-->
      <!--     <p class="gray">页面编码描述用于前端个人中心显示</p>-->
      <!--</el-form-item>-->

      <!--风格选择-->
      <el-form-item label="风格选择：">
        <el-radio-group v-model="curItem.style.chooseTitleStyle">
          <el-radio :label="'global'">使用全局</el-radio>
          <el-radio :label="'customize'">自定义</el-radio>
        </el-radio-group>
      </el-form-item>
                  <!--选择角色-->
            <!-- -->
            <el-form-item label="选择角色：">
        <el-select size="small" v-model="curItem.style.role_id" placeholder="选择手机角色">
            <el-option :label="item.label" :value="item.value" v-for="(item,index) in roleArr" :key="index"></el-option>
            
         </el-select>


        <div>如果不选择角色，则默认用户主页</div>
      </el-form-item>
      <!--文字颜色-->
      <el-form-item v-if="curItem.style.chooseTitleStyle==='customize'" label="文字颜色：">
        <el-radio-group v-model="curItem.style.titleTextColor">
          <el-radio :label="'black'">黑色</el-radio>
          <el-radio :label="'white'">白色</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 背景颜色 -->
      <el-form-item v-if="curItem.style.chooseTitleStyle==='customize'" label="背景颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.titleBackgroundColor"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'titleBackgroundColor', '#ffffff')">重置</el-button>
        </div>
      </el-form-item>
      <!--上传图片组件-->
      <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    </el-form>
    <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</Setlink>
  </div>
</template>

<script>
  import Upload from '@/components/file/Upload';
  import Setlink from '@/components/setlink/Setlink';
  import PageApi from '@/api/page.js';
  export default {
    components: {
      Upload,
      Setlink,
    },
    data() {
      return {
        image_id:'',
         /*是否上传图片*/
        isupload: false,
        index: null,
        urlList : [],
        /*是否选择链接*/
        is_linkset: false,
        roleArr:[]
      };
    },
    props: ['curItem', 'selectedIndex', 'opts'],
    created() {
      this.getMobileRole()
    },
    methods: {
      getMobileRole(){
        var self = this;
        PageApi.getMobileRole({}, true)
          .then(data => {
        
            self.roleArr = data.data
            
          })
          .catch(error => {
        
          });
      },
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        console.log(e);
        if (e != null && e.length > 0) {
          this.file_path = e[0].file_path;
          this.image_id = e[0].file_id;
          this.curItem.params.img_url = this.file_path;
        }
        this.isupload = false;
      },


      /*选择链接*/
        changeLink(index) {
            this.is_linkset = true;
            this.index = index;
        },

    /*获取链接并关闭弹窗*/
      closeLinkset(e) {
          this.is_linkset = false;
          if (e) {
            this.curItem.params.icon_link=e.url;
            // this.curItem.data[this.index].name = e.name;
          }
      },
    }
  };
</script>

<style>
  .img {
     margin-top: 10px;
   }
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Setpages2.vue